import BlankEtc from '@components/blank/BlankEtc';
import Column from '@components/Column';
import { useFlow } from '@stackflow/react';
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

import { itemCouponDraftAtom } from '../atoms';
import CouponCard from './CouponCard';
import useItemCoupons, { ItemCouponState } from '../hooks/useItemCoupons';

/** 상품 쿠폰 목록. 적용할 상품이 여러 개면 적용할 상품 모달을 띄운다 */
function ItemCouponList() {
    const { t } = useTranslation('order');
    const { push } = useFlow();
    const items = useItemCoupons();
    const [draft, setDraft] = useAtom(itemCouponDraftAtom);

    const openTargetSheet = (couponId: string) => {
        push('ItemCouponTargetBottomSheet', { couponId });
    };

    const toggle = ({
        coupon, options, candidates, assigned,
    }: ItemCouponState) => {
        if (assigned) {
            const { [coupon.id]: _, ...rest } = draft;
            setDraft(rest);
            return;
        }
        // 적용할 수 있는 상품이 여러 개면 직접 고르게 한다
        if (options.length > 1) {
            openTargetSheet(coupon.id);
            return;
        }
        if (candidates.length === 1) {
            setDraft({ ...draft, [coupon.id]: candidates[0].target });
        }
    };

    if (items.length === 0) {
        return (
            <BlankEtc>
                {t('couponPage.empty')}
            </BlankEtc>
        );
    }
    return (
        <Column fullWidth spacing={2}>
            {items.map((item) => {
                const {
                    coupon, options, candidates, assigned,
                } = item;
                return (
                    <CouponCard key={coupon.id}
                        coupon={coupon}
                        isSelected={!!assigned}
                        disabled={!assigned && candidates.length === 0}
                        targetName={assigned?.line.itemName}
                        onChangeTarget={options.length > 1 ? () => openTargetSheet(coupon.id) : undefined}
                        onToggle={() => toggle(item)} />
                );
            })}
        </Column>
    );
}

export default ItemCouponList;
